import {
  Document,
  Page,
  Path,
  PDFViewer,
  StyleSheet,
  Svg,
  Text,
  View,
} from "@react-pdf/renderer";

const Checkbox = ({ label, checked }: { label: string; checked: boolean }) => (
  <View
    style={{
      flexDirection: "row",
      alignItems: "center",
    }}
  >
    <View
      style={{
        width: 10,
        height: 10,
        border: 1,
        justifyContent: "center",
        alignItems: "center",
        marginRight: 5,
        fontSize: 6,
      }}
    >
      {checked && (
        <Svg viewBox="0 0 16 16" width={10} height={10}>
          <Path
            d="M2 8 L6 12 L14 2"
            stroke="black"
            strokeWidth={1}
            fill="none"
          />
        </Svg>
      )}
    </View>
    <Text>{label}</Text>
  </View>
);

const fontStyles = StyleSheet.create({
  TextCenter: {
    textAlign: "center",
  },
  boldText: {
    fontWeight: "bold",
  },
  fontXL: {
    fontSize: 12,
  },
  fontLg: {
    fontSize: 10,
  },
  fontMd: {
    fontSize: 9,
  },
  fontSm: { fontSize: 7.4 },
});

export const styles = StyleSheet.create({
  ...fontStyles,
  page: {
    paddingHorizontal: 30,
    paddingVertical: 15,
    fontFamily: "HostGrotesk",
    backgroundColor: "white",
    ...fontStyles.fontMd,
  },
  header: {
    marginTop: 5,
    marginBottom: 10,
    ...fontStyles.fontXL,
  },
  table: {
    borderTop: 1,
    borderLeft: 1,
    width: "100%",
  },
  tableRow: {
    width: "100%",
    flexDirection: "row",
    borderBottom: 1,
  },
  tableCell: {
    paddingHorizontal: 3,
    borderRight: 1,
    flexDirection: "row",
  },
  flex: { flexDirection: "row" },
  centerDiv: {
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
  },
  checkbox: {
    width: 10,
    aspectRatio: 1,
    marginRight: 5,
    border: 1,
    fontSize: 6,
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    flexGrow: 1,
  },
  logo: {
    height: 100,
    width: 100,
    border: 1,
  },
});

const PriorNoticeInvoice = () => {
  const productDataLength = 1;
  const maxRows = 4;
  const productRowHeight = 60;
  const emptyRowHeight =
    productRowHeight * maxRows - productDataLength * productRowHeight;

  return (
    <PDFViewer width="100%" height="800">
      <Document>
        <Page style={styles.page} size="A4">
          <View style={[styles.table]}>
            {/* Header */}
            <View
              style={[
                styles.centerDiv,
                { borderBottom: 1, borderRight: 1, paddingVertical: 10 },
              ]}
            >
              <Text style={[styles.fontLg, styles.boldText]}>PRIOR NOTICE</Text>
              <Text>Reference Number T.20250306.GDCP37</Text>
            </View>

            {/* Importer-Exporter details */}
            <View>
              <View style={[styles.tableRow, styles.tableCell]}>
                <Text style={[styles.boldText]}>COUNTRY OF ORIGIN : </Text>
                <Text>INDIA</Text>
              </View>
              <View style={[styles.tableRow, styles.tableCell]}>
                <Text style={[styles.boldText]}>COUNTRY OF EXPORT : </Text>
                <Text>SURAT, GUJARAT, INDIA</Text>
              </View>

              {/* Export description */}
              <View style={[styles.tableRow, styles.boldText]}>
                <View
                  style={[
                    styles.tableCell,
                    styles.centerDiv,
                    styles.fontLg,
                    { width: "25%" },
                  ]}
                >
                  <Text>Description of Exporter/Representative*</Text>
                </View>
                <View style={{ width: "75%" }}>
                  <View style={[styles.tableRow]}>
                    <Text style={[styles.tableCell, { width: "20%" }]}>
                      Name
                    </Text>
                    <Text style={[styles.tableCell, { width: "25%" }]}>
                      BHAVESH PATEL
                    </Text>
                    <Text style={[styles.tableCell, { width: "20%" }]}>
                      Company name
                    </Text>
                    <Text style={[styles.tableCell, { width: "35%" }]}>
                      MS. LAXMI ENTERPRISE
                    </Text>
                  </View>

                  <View style={[styles.tableRow]}>
                    <Text style={[styles.tableCell, { width: "20%" }]}>
                      Address
                    </Text>
                    <Text style={[styles.tableCell, { width: "80%" }]}>
                      PLOT NO-36, GROUND FLOOR, SHUBHAM INDUSTRY-2, SANIYA
                      HEMED, SURAT, GUJARAT, 395006 (INDIA)
                    </Text>
                  </View>

                  <View style={[styles.tableRow]}>
                    <Text style={[styles.tableCell, { width: "45%" }]}>
                      Phone/Fax. Number
                    </Text>
                    <Text style={[styles.tableCell, { width: "55%" }]}>
                      +917777995599
                    </Text>
                  </View>

                  <View style={[styles.tableRow, { borderBottom: 0 }]}>
                    <Text style={[styles.tableCell, { width: "20%" }]}>
                      Email
                    </Text>
                    <Text style={[styles.tableCell, { width: "80%" }]}>
                      enfinyexim@gmail.com
                    </Text>
                  </View>
                </View>
              </View>

              {/* importer description */}
              <View style={[styles.tableRow, styles.boldText]}>
                <View
                  style={[
                    styles.tableCell,
                    styles.centerDiv,
                    styles.fontLg,
                    { width: "25%" },
                  ]}
                >
                  <Text>Description of Importer/Representative*</Text>
                </View>
                <View style={{ width: "75%" }}>
                  <View style={[styles.tableRow]}>
                    <Text style={[styles.tableCell, { width: "20%" }]}>
                      Name
                    </Text>
                    <Text style={[styles.tableCell, { width: "25%" }]}>
                      KRISHNAN
                    </Text>
                    <Text style={[styles.tableCell, { width: "20%" }]}>
                      Company name
                    </Text>
                    <Text style={[styles.tableCell, { width: "35%" }]}>
                      PT NERKAT JAYA ONGGUL
                    </Text>
                  </View>

                  <View style={[styles.tableRow]}>
                    <Text style={[styles.tableCell, { width: "20%" }]}>
                      Address
                    </Text>
                    <Text style={[styles.tableCell, { width: "80%" }]}>
                      JALAN ROMOKALISARI 82B, JBENOWO, SURABAYA, 60192,
                      INDONESIA NPWP: 0759 2123 1960 4000
                    </Text>
                  </View>

                  <View style={[styles.tableRow]}>
                    <Text style={[styles.tableCell, { width: "45%" }]}>
                      Phone/Fax. Number
                    </Text>
                    <Text style={[styles.tableCell, { width: "55%" }]}>
                      +62 817 1717 5085
                    </Text>
                  </View>

                  <View style={[styles.tableRow, { borderBottom: 0 }]}>
                    <Text style={[styles.tableCell, { width: "20%" }]}>
                      Email
                    </Text>
                    <Text style={[styles.tableCell, { width: "80%" }]}>
                      ptberkatjayaonggul@gmail.com
                    </Text>
                  </View>
                </View>
              </View>
            </View>

            {/* DESCRIPTION OF COMMODITY/CONSIGNMENT */}
            <View>
              <View
                style={[
                  styles.tableRow,
                  styles.tableCell,
                  styles.centerDiv,
                  styles.boldText,
                ]}
              >
                <Text>DESCRIPTION OF COMMODITY/CONSIGNMENT</Text>
              </View>

              {/* checkbox */}
              <View
                style={[
                  styles.tableRow,
                  styles.tableCell,
                  styles.boldText,
                  { gap: 90, paddingLeft: 20, height: 18 },
                ]}
              >
                <Checkbox label="Non GMO" checked={true} />
                <Checkbox
                  label="GMO: the CoA's reference no & date"
                  checked={false}
                />
              </View>
            </View>

            {/* Main PRODUCT table */}
            <View>
              {/* Table header*/}
              <View style={[styles.tableRow, styles.boldText]}>
                <View
                  style={[styles.tableCell, styles.centerDiv, { width: "5%" }]}
                >
                  <Text>No</Text>
                </View>
                <View
                  style={[styles.tableCell, styles.centerDiv, { width: "15%" }]}
                >
                  <Text>Common Name/Scientific Name</Text>
                </View>
                <View
                  style={[styles.tableCell, styles.centerDiv, { width: "10%" }]}
                >
                  <Text>HS Code</Text>
                </View>
                <View
                  style={[styles.tableCell, styles.centerDiv, { width: "20%" }]}
                >
                  <Text>Quantity/Packaging</Text>
                </View>
                <View
                  style={[styles.tableCell, styles.centerDiv, { width: "30%" }]}
                >
                  <Text>
                    Certificate of Analysis/Health Certificate's Reference
                    Number and issued date*)
                  </Text>
                </View>
                <View
                  style={[styles.tableCell, styles.centerDiv, { width: "20%" }]}
                >
                  <Text>Testing Laboratory/NFSCA Body*)</Text>
                </View>
              </View>

              {/*Table Rows */}
              <View
                style={[styles.tableRow, styles.boldText, { minHeight: 60 }]}
              >
                <View
                  style={[styles.tableCell, styles.centerDiv, { width: "5%" }]}
                >
                  <Text>1</Text>
                </View>
                <View
                  style={[styles.tableCell, styles.centerDiv, { width: "15%" }]}
                >
                  <Text>Arachis hypogaea</Text>
                </View>
                <View
                  style={[styles.tableCell, styles.centerDiv, { width: "10%" }]}
                >
                  <Text>12024200</Text>
                </View>
                <View
                  style={[styles.tableCell, styles.centerDiv, { width: "20%" }]}
                >
                  <Text>78000 net kilogram / 1560 BG</Text>
                </View>
                <View
                  style={[
                    styles.tableCell,
                    styles.centerDiv,
                    { flexDirection: "column", width: "30%" },
                  ]}
                >
                  <Text>AL/AHD/02010325045</Text>
                  <Text>AL/AHD/02010325046</Text>
                  <Text>AL/AHD/02010325047</Text>
                  <Text>AL/AHD/02010325048 (2025-03-01)</Text>
                </View>
                <View
                  style={[styles.tableCell, styles.centerDiv, { width: "20%" }]}
                >
                  <Text>IDLAB.2.IN001</Text>
                </View>
              </View>

              {/* Empty row */}
              <View
                style={[
                  styles.tableRow,
                  styles.boldText,
                  { minHeight: emptyRowHeight },
                ]}
              >
                <View style={[styles.tableCell, { width: "5%" }]}></View>
                <View style={[styles.tableCell, { width: "15%" }]}></View>
                <View style={[styles.tableCell, { width: "10%" }]}></View>
                <View style={[styles.tableCell, { width: "20%" }]}></View>
                <View
                  style={[
                    styles.tableCell,
                    { flexDirection: "column", width: "30%" },
                  ]}
                ></View>
                <View style={[styles.tableCell, { width: "20%" }]}></View>
              </View>
            </View>

            {/* EXPORT PURPOSE & DEGREE OF PROCESSING*/}
            <View>
              <View style={[styles.tableRow]}>
                <Text style={[styles.tableCell, { width: "30%" }]}>
                  EXPORT PURPOSE
                </Text>
                <Text style={[styles.tableCell, { width: "70%" }]}>
                  Consumption
                </Text>
              </View>

              <View style={[styles.tableRow]}>
                <Text style={[styles.tableCell, { width: "30%" }]}>
                  DEGREE OF PROCESSING
                </Text>
                <View
                  style={[
                    styles.tableCell,
                    {
                      width: "70%",
                      paddingRight: 7,
                      columnGap: 30,
                      flexWrap: "wrap",
                    },
                  ]}
                >
                  <Checkbox label="Fresh" checked={true} />
                  <Checkbox label="Minimal processed" checked={false} />
                  <Checkbox label="Full processed" checked={false} />
                  <Checkbox label="Other" checked={false} />
                </View>
              </View>
            </View>

            {/* HEALTH/SANITARY/PHYTOSANITARY CERTIFICATE */}
            <View>
              <View
                style={[
                  styles.tableRow,
                  styles.tableCell,
                  styles.centerDiv,
                  styles.boldText,
                ]}
              >
                <Text>HEALTH/SANITARY/PHYTOSANITARY CERTIFICATE*</Text>
              </View>

              {/* Header */}
              <View style={[styles.tableRow, styles.boldText]}>
                <View
                  style={[styles.tableCell, styles.centerDiv, { width: "5%" }]}
                >
                  <Text>No</Text>
                </View>
                <View
                  style={[styles.tableCell, styles.centerDiv, { width: "37%" }]}
                >
                  <Text>Reference Number</Text>
                </View>
                <View
                  style={[styles.tableCell, styles.centerDiv, { width: "33%" }]}
                >
                  <Text>place of Issue</Text>
                </View>
                <View
                  style={[styles.tableCell, styles.centerDiv, { width: "25%" }]}
                >
                  <Text>Date of Issue</Text>
                </View>
              </View>

              {/* Table Rows */}
              <View style={[styles.tableRow]}>
                <Text style={[styles.tableCell, { width: "5%" }]}>1</Text>
                <Text style={[styles.tableCell, { width: "37%" }]}>
                  PSC81JAM2025003544
                </Text>
                <Text style={[styles.tableCell, { width: "33%" }]}>
                  JAMNAGAR
                </Text>
                <Text style={[styles.tableCell, { width: "25%" }]}>
                  2025-03-07
                </Text>
              </View>
            </View>

            {/* PORT details table*/}
            <View>
              {/* Row-1 */}
              <View style={[styles.tableRow]}>
                <Text style={[styles.tableCell, { width: "25%" }]}>
                  Means of conveyance
                </Text>
                <Text
                  style={[styles.tableCell, styles.boldText, { width: "25%" }]}
                >
                  SEA
                </Text>
                <Text style={[styles.tableCell, { width: "25%" }]}>
                  Voyage/Flight number
                </Text>
                <Text
                  style={[styles.tableCell, styles.boldText, { width: "25%" }]}
                >
                  WAN HAI 337 / E005
                </Text>
              </View>
              {/* Row-2 */}
              <View style={[styles.tableRow]}>
                <Text style={[styles.tableCell, { width: "25%" }]}>
                  Port of loading
                </Text>
                <Text
                  style={[styles.tableCell, styles.boldText, { width: "25%" }]}
                >
                  INMUN
                </Text>
                <Text style={[styles.tableCell, { width: "25%" }]}>
                  Date of loading
                </Text>
                <Text
                  style={[styles.tableCell, styles.boldText, { width: "25%" }]}
                >
                  2025-03-08
                </Text>
              </View>
              {/* Row-3 */}
              <View style={[styles.tableRow]}>
                <Text style={[styles.tableCell, { width: "25%" }]}>
                  Place of destination
                </Text>
                <Text
                  style={[styles.tableCell, styles.boldText, { width: "25%" }]}
                >
                  SURABAYA
                </Text>
                <Text style={[styles.tableCell, { width: "25%" }]}>
                  Date of estimated arrival
                </Text>
                <Text
                  style={[styles.tableCell, styles.boldText, { width: "25%" }]}
                >
                  2025-03-21
                </Text>
              </View>
            </View>

            {/* Additional information */}
            <View
              style={[
                styles.tableRow,
                styles.tableCell,
                { flexDirection: "column" },
              ]}
            >
              <Text>Additional information:</Text>
              <View style={[styles.flex]}>
                <Text>Container's identification Number*: </Text>
                <Text style={[styles.boldText]}>
                  TEMU3492511;SEGU2378410;FCIU6520890;FTAU1021332
                </Text>
              </View>
              <Text>Other (specify):</Text>
            </View>

            {/* Footer */}
            <View
              style={[
                styles.tableRow,
                styles.tableCell,
                styles.boldText,
                {
                  justifyContent: "space-between",
                  height: 150,
                  paddingHorizontal: 20,
                },
              ]}
            >
              <View style={[styles.centerDiv, { flexDirection: "column" }]}>
                <View style={[styles.logo]}></View>
                <Text>Qr Code</Text>
              </View>
              <View
                style={[
                  styles.centerDiv,
                  {
                    justifyContent: "flex-start",
                    paddingTop: 10,
                  },
                ]}
              >
                <Text>Place: SURAT, GUJARAT, INDIA</Text>
                <Text>Date: 2025-03-12</Text>
              </View>
              <View style={[styles.centerDiv, { flexDirection: "column" }]}>
                <View style={[styles.logo]}></View>
                <Text>Applicant</Text>
              </View>
            </View>
          </View>
        </Page>
      </Document>
    </PDFViewer>
  );
};

export default PriorNoticeInvoice;
